module.exports = __webpack_public_path__ + "static/media/report-teacher.70109852.png";